var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      ref: "dialog",
      attrs: {
        color: "error",
        icon: "priority_high",
        "store-modal": "",
        title: _vm.generateMessage("requests.actions.rejection")
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2 text-validate-btn",
                      attrs: {
                        small: "",
                        color: "error",
                        disabled: !_vm.valid,
                        loading: _vm.isLoading
                      },
                      on: { click: _vm.reject }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage("requests.actions.validate")
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { small: "" },
                      on: { click: _vm.cancel }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage("requests.actions.cancel")
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex mt-2" },
            [
              _c("v-select", {
                staticClass: "mx-2 test-select",
                staticStyle: { "max-width": "200px" },
                attrs: {
                  "item-text": "name",
                  "item-value": "code",
                  items: _vm.items,
                  placeholder:
                    _vm.generateMessage("requests.actions.rejection_reason") +
                    " *",
                  rules: [
                    v =>
                      !!v ||
                      _vm.generateMessage(
                        "requests.actions.no_rejection_reason"
                      )
                  ],
                  color: "error",
                  clearable: "",
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.reject_code,
                  callback: function($$v) {
                    _vm.reject_code = $$v
                  },
                  expression: "reject_code"
                }
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                staticClass: "mx-2",
                attrs: {
                  label: _vm.generateMessage(
                    "requests.actions.engiedirect_visible"
                  ),
                  color: "error"
                },
                model: {
                  value: _vm.customer_visibility,
                  callback: function($$v) {
                    _vm.customer_visibility = $$v
                  },
                  expression: "customer_visibility"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("custom-text-area", {
            staticClass: "mx-2 test-textarea",
            attrs: {
              color: "error",
              maxCharacter: 60,
              errorTooLongMsg: "Maximum 60 caractères",
              label: _vm.generateMessage("requests.actions.comment")
            },
            model: {
              value: _vm.reject_description,
              callback: function($$v) {
                _vm.reject_description = $$v
              },
              expression: "reject_description"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }